(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["team-store-iframe"] && !Shopify.designMode) return;
  try {
    
    let shopify_customer_id = __st.cid;
    let currentSessionId = window.localStorage.getItem('kd_session_id');
    if (!currentSessionId && !shopify_customer_id) {
      currentSessionId = Math.random().toString(36).slice(2, 12);
      window.localStorage.setItem('kd_session_id', currentSessionId);
    }

    window.addEventListener(
      'message',
      function (event) {
        $('#teamStore').height(event.data);
      },
      false
    );

    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventer = window[eventMethod];
    var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
    let addToCartButton = document.querySelector("#add-to-cart-button")
    addToCartButton.addEventListener("click", e => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent("theme:cart:add", {detail: {button: e.target}}));
    })



  eventer(messageEvent, async function (e) {
    if (e.data?.action === 'updateCart') {
      const formData = e.data?.list;
      const officialOrderNumber = e.data?.officialOrderNumber;

      if (!formData?.items || formData.items.length === 0) return;

      let delay = 2500;

      // Wait for all products to be added
      for (let item of formData.items) {
        await new Promise(resolve => {
          setTimeout(() => {
            document.querySelector("#product-id").value = item.id;
            document.querySelector("#quantity").value = item.quantity;
            document.querySelector("#custom-notes").value = item.properties?.['custom_notes'];
            addToCartButton.click();
            resolve();
          }, delay);
        });
      }

      // After all add-to-cart actions, update cart attributes
      if (officialOrderNumber) {
        const form = new FormData();
        form.append("attributes[Official Order Number]", officialOrderNumber);

        fetch('/cart/update.js', {
          method: 'POST',
          body: form
        })
        .then(res => res.json())
        .then(data => console.log('Cart updated with Reference Number:', data))
        .catch(err => console.error('Error updating cart:', err));
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
